import React from "react";
import classes from "./ProductCardDetailSkeleton.module.css";

export default function ProductCardDetailSkeleton() {
  return (
    <div className={classes.detailWrapper}>
      {/* Two Columns */}
      <div className={classes.twoColumnRow}>
        {/* Left – Image Column */}
        <div className={classes.imageColumn}>
          <div className={classes.mainImageSkeleton}></div>
          <div className={classes.thumbsRow}>
            {Array.from({ length: 4 }).map((_, idx) => (
              <div key={idx} className={classes.thumbnailSkeleton}></div>
            ))}
          </div>
        </div>

        {/* Right – Info Column */}
        <div className={classes.infoColumn}>
          <div className={classes.titleSkeleton}></div>
          <div className={classes.shortDescSkeleton}></div>

          <div className={classes.priceWrap}>
            <div className={classes.priceSkeleton}></div>
          </div>

          {/* Specs Table */}
          <div className={classes.specsTableSkeleton}>
            {Array.from({ length: 5 }).map((_, idx) => (
              <div key={idx} className={classes.specRowSkeleton}>
                <div className={classes.specLabelSkeleton}></div>
                <div className={classes.specValueSkeleton}></div>
              </div>
            ))}
          </div>

          {/* Benefits */}
          <div className={classes.benefitsBottom}>
            {Array.from({ length: 4 }).map((_, idx) => (
              <div key={idx} className={classes.benefitCardSkeleton}></div>
            ))}
          </div>

          {/* Actions */}
          <div className={classes.actionsRow}>
            <div className={classes.buttonSkeleton}></div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className={classes.tabsRow}>
        <div className={classes.tabBtnSkeleton}></div>
        <div className={classes.tabContentSkeleton}>
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className={classes.textLineSkeleton}></div>
          ))}
        </div>
      </div>
    </div>
  );
}
